import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OrphanSummary } from '../types';
import SceneCover from './SceneCover';
import SummaryChips from './SummaryChips';
import Chevron from './Chevron';
import AssignDropdown, { TripOption } from './AssignDropdown';

// One orphan journey as a row (design-handoff.md C.4): mini cover + title + stats +
// AssignDropdown + Chevron. The whole row opens the shared Journey detail page;
// the dropdown does NOT trigger navigation (it stops propagation itself).

export interface AssignRowProps {
  orphan: OrphanSummary;
  trips: TripOption[];
  onAssigned: () => void;
}

const AssignRow: React.FC<AssignRowProps> = ({ orphan, trips, onAssigned }) => {
  const navigate = useNavigate();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/journeys/${encodeURIComponent(orphan.id)}`)}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/journeys/${encodeURIComponent(orphan.id)}`); }}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: '#ffffff',
        border: '1px solid rgba(20,40,30,0.10)',
        borderRadius: 16,
        padding: 12,
        cursor: 'pointer',
      }}
    >
      <div style={{ width: 56, height: 56, borderRadius: 12, overflow: 'hidden', flexShrink: 0 }}>
        <SceneCover template={orphan.cover.template} palette={orphan.cover.palette} />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontWeight: 600,
            color: '#16241d',
            fontSize: 15,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {orphan.title || 'Untitled journey'}
        </div>
        <div style={{ marginTop: 6 }}>
          <SummaryChips summary={orphan} />
        </div>
        <div style={{ marginTop: 8 }}>
          <AssignDropdown journeyId={orphan.id} trips={trips} onAssigned={onAssigned} newTripDefaultName={orphan.title || ''} />
        </div>
      </div>

      <Chevron />
    </div>
  );
};

export default AssignRow;
